import React from "react";
import { HOW_IT_WORKS_STEPS } from "../marketingData";

const StepIcon = ({ type }) => {
  const icons = {
    box: <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z" />,
    arrow: (
      <>
        <path d="M5 12h14" />
        <path d="M12 5l7 7-7 7" />
      </>
    ),
    truck: (
      <>
        <path d="M1 3h15v13H1z" />
        <path d="M16 8h4l3 3v5h-7V8z" />
        <circle cx="5.5" cy="18.5" r="2.5" />
        <circle cx="18.5" cy="18.5" r="2.5" />
      </>
    ),
    check: (
      <>
        <path d="M22 11.08V12a10 10 0 11-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </>
    ),
    chart: (
      <>
        <line x1="18" y1="20" x2="18" y2="10" />
        <line x1="12" y1="20" x2="12" y2="4" />
        <line x1="6" y1="20" x2="6" y2="14" />
      </>
    ),
    shield: <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />,
  };
  return (
    <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
      {icons[type]}
    </svg>
  );
};

const HowItWorksSection = () => (
  <div className="how-section" id="how">
    <div className="how-inner">
      <div className="how-header reveal">
        <span className="section-eyebrow">How it works</span>
        <h2 className="section-h2">
          From signup to
          <br />
          <em>first sale in minutes.</em>
        </h2>
      </div>
      <div className="flip-grid">
        {HOW_IT_WORKS_STEPS.map((step, index) => (
          <div className={`flip-wrap reveal stagger-${(index % 3) + 1}`} key={step.num}>
            <div className="flip-inner">
              <div className="flip-front">
                <div className="f-img" style={{ backgroundImage: `url('${step.image}')` }} />
                <div className="f-overlay" />
                <div className="f-content">
                  <div className="f-top">
                    <div className="f-num">{step.num}</div>
                    <div className="f-icon">
                      <StepIcon type={step.icon} />
                    </div>
                  </div>
                  <div>
                    <div className="f-title">{step.title}</div>
                    <div className="f-badge">{step.badge}</div>
                  </div>
                </div>
              </div>
              <div className="flip-back">
                <div className="b-img" style={{ backgroundImage: `url('${step.image}')` }} />
                <div className="b-overlay" />
                <div className="b-content">
                  <div className="b-num">{step.num}</div>
                  <div className="b-desc">{step.desc}</div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default HowItWorksSection;
